import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDipBatchEvidencesJobsDocument,
  type GetDipBatchEvidencesJobsQuery,
  type GetDipBatchEvidencesJobsQueryVariables,
} from "~/features/dataImportProjects/gqls";

/** Read-only batch evidences jobs for the DIP (Import section source). */
export function useDipBatchEvidencesJobs(dataImportProjectId: string) {
  return useSuspenseQuery<GetDipBatchEvidencesJobsQuery, GetDipBatchEvidencesJobsQueryVariables>(
    GetDipBatchEvidencesJobsDocument,
    {
      variables: { dataImportProjectId },
    },
  );
}
